import styled from 'styled-components';
import { rem } from 'polished';

const CopiedIcon = styled.div`
    display: flex;
    margin-right: ${rem(8)};
`;

export default CopiedIcon;
